<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="text"
    item-value="partCatCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'PartCatInput',

  mixins: [APIUtils, Message],

  components: {
    SelectSingleInput,
  },

  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0287')
      },
    },
  },

  methods: {},

  async mounted() {
    this.loading = true
    try {
      const params = {}
      if (this.validOnly) {
        params.validOnly = true
      }

      const elements = await API.get('/master/partCats', params)

      elements.forEach((item) => {
        item['text'] = `${item['partCatCd']} : ${item['partCatName']}`
        this.items.push(item)
      })
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0011') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
